@if (!shops.length) {
  <sd-no-shops></sd-no-shops>
} @else {
  <ng-container
    *ngIf="{
      shopsSorted: shopsSorted$ | async,
      activeShopName: activeId$ | async,
    } as obs"
  >
    <div class="shop-desktop container-v2">
      <h1 class="shop-desktop-title text-h3-m text-xl-h3-l">
        <span class="shop-desktop-title-count-shop">{{ title[0] }}</span>
        <span class="shop-desktop-title-current-city">{{ title[1] }}</span>
      </h1>

      <div class="shop-desktop-address-suggestions-select">
        <ui-address-suggestions-select (changeAddress)="onChangeAddress($event)"></ui-address-suggestions-select>
      </div>

      <div class="shop-desktop-shops">
        <div #shopListRef class="shop-desktop-shops-list">
          <sd-shop-list
            [shops]="obs.shopsSorted"
            [activeShopName]="obs.activeShopName"
            (clickShop)="onClickShop($event)"
          ></sd-shop-list>
        </div>
        <div class="shop-desktop-shops-map">
          <sd-shop-map
            class="shop-desktop-shops-map-instance"
            [shops]="shops"
            (created)="onMapCreated($event)"
            [placemarksProps]="getPlacemarksProps"
            [placemarkIconOptions]="getPlacemarkIconOptions"
          ></sd-shop-map>
        </div>
      </div>
    </div>
  </ng-container>
}
